import { assertEvent, assign } from 'xstate5';

import { decreaseDressingWeight } from '../../helpers';

import type { CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Handles the logic to decrease the weight of a specific dressing ingredient
 * within the mixed dressing details.
 */
export const decreaseMixedDressingWeight: CustomizationMachineAction = assign((args) => {
  const { event, context } = args;
  const { mixedDressingDetails } = context;

  assertEvent(event, 'customization.dressing.decrease-weight');

  const { ingredientId } = event;

  return {
    mixedDressingDetails: decreaseDressingWeight({ ingredientId, mixedDressingDetails }), // prettier-ignore
  };
});
